<div class="col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11 text-center m-auto  ">


  <!-- formulaire enrollement -->
  <div class="card"  style="padding: 10px;">
    <div class="d-flex justify-content-center">
      <h5 id="heading">Complément de piéces</h5>
      <button type="button"  class="btn btn-link position-absolute" style="top: 10px; right: 10px;" aria-label="Close" (click)="closeModal()">
        <i class="fas fa-times text-dark" style="font-size: 1.5rem; "></i>
      </button>
    </div>
   <!-- <p>Fill all form field to go to next step</p> -->
   <form #form="ngForm" (ngSubmit)="onSubmit(form)" novalidate id="msform">
    <ul id="progressbar">
      <li class="active" id="step1"><strong>informations à ajouter </strong></li>
    </ul>
  
    <fieldset>
      <div class="d-flex justify-content-between flex-wrap w-80">
        <div class="col-md-3 mb-3 mb-md-0 col-sm-10">
          <label class="fieldlabels">Nom du formulaire: *</label>
          <input class="form-control" type="text" name="name_form" required [(ngModel)]="formName" />
        </div>
  
        <div class="mr-3 col-md-8 col-sm-12">
          <label class="fieldlabels text-dark float-left" (click)="addField()">Nouveau champ: 
            <i id="addRowBtn_inf" class="fa fa-solid fa-plus text-success mt-3" style="font-size:15px; cursor:pointer"></i>
          </label>
  
          <div class="table-responsive">
            <table id="myTable" class="table text-nowrap text-center m-auto">
              <tbody>
                <tr *ngFor="let field of fields_form; let i = index">
                  <td>
                    <input type="text" class="form-control" placeholder="Nom du champ" [(ngModel)]="field.name" name="name_field_{{i}}" required />
                  </td>
                  <td>
                    <select class="form-control" [(ngModel)]="field.type" (change)="getOptions(field, i)" required name="type_field_{{i}}">
                      <option value="">--choix du type--</option>
                      <option *ngFor="let type of field_type" [value]="type.ref">{{ type.type }}</option>
                    </select>
                  </td>
  
                  <ng-container *ngIf="field.type === 'ET-5'">
                    <td>
                      <div class="form-group">
                        <input class="form-control text-nowrap" placeholder="option1;option2;option3" [(ngModel)]="field.optionsInput" name="options_{{i}}" />
                      </div>
                    </td>
                   
                  </ng-container>
  
                  <td>
                    <i class="fas fa-solid fa-trash delete-row text-danger mt-2" (click)="deleteField(i)" style="font-size:15px; cursor:pointer"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  
      <input type="submit" name="next" class="next action-button bg-dark" style="margin-left: 7%; min-width: 200px;" value="Enregistrer" />
    </fieldset>
  </form>
  


</div>
<ngx-ui-loader [loaderId]="'complements_pieces'"></ngx-ui-loader>
